import { createAction, props } from '@ngrx/store';
import { TenantDto } from '../../models';

export const loadCurrentTenantSuccess = createAction(
  '[Tenant] Load Current Tenant Success',
  props<{ tenant: TenantDto }>()
);

export const loadCurrentTenantFailure = createAction(
  '[Tenant] Load Current Tenant Failure',
  props<{ error: string }>()
);

export const clearCurrentTenant = createAction('[Tenant] Clear Current Tenant');
